import { FC, ReactNode } from 'react'

import { LoadingButton } from '@mui/lab'
import { Alert, SvgIcon } from '@mui/material'

import { Typo } from '~/core/components/alias'

export const ComplexAlert: FC<{
  icon: React.ElementType
  title: string
  desc: ReactNode
  actionText?: string
  onClick?: () => void
  loading?: boolean
}> = (props) => (
  <Alert
    severity="warning"
    action={
      !!props.actionText && (
        <LoadingButton variant="outlined" loading={props.loading} onClick={props.onClick}>
          {props.actionText}
        </LoadingButton>
      )
    }
    icon={<SvgIcon fontSize="large" inheritViewBox component={props.icon} />}
  >
    <Typo variant="body1">{props.title}</Typo>
    <Typo variant="body2" color="text.secondary">
      {props.desc}
    </Typo>
  </Alert>
)
